export default __webpack_public_path__ + "static/scroll_to_top-4e035c516392ecd6cb6f526635e8ee6b.png";